module.exports = __webpack_public_path__ + "img/IMG_1024_L.ced13012.webp";